// 接口域名
//export const domain = 'http://localhost:44380'; //=============测试环境
//export const domain = 'http://rccode.f3322.org:4670/'; //=============测试环境
//export const domain = 'http://nsecs.picp.net/'; //=============测试环境
export const domain = 'http://wx.jctopinfo.com/'; //=============生产环境
   
// 导出接口api
export default 
{
    API_InfomationQuery: 'Account/API_Infomation', //配置信息获取
    API_StationQuery: 'Account/API_StationQuery', //营运车站列表
    API_HotLineQuery: 'Account/API_LineQuery', //营运热门线路    
    API_StartNodeQuery: 'BookSeatsApi/API_StartNodeQuery', //上车点获取
    API_StartNodeQueryByDstNode: 'BookSeatsApi/API_StartNodeQueryByDstNode', //上车点获取
    API_ArrivalNodeQuery: 'BookSeatsApi/API_ArrivalNodeQuery', //下车点获取
    API_LineClassDaySaleQuery: 'BookSeatsApi/API_LineClassDaySaleQuery', //获取售票班次
    API_LineClassDayQuery: 'BookSeatsApi/API_LineClassSaleQuery', //获取班次详情（按线路）
    API_ScheLineByGroup: 'BookSeatsApi/API_ScheLineByGroup', //获取班次详情（按组）
    API_ClassQueryByEmployee: 'BookSeatsApi/API_ClassSaleQueryByEmployee', //获取班次详情（职工班次查询）  
    API_LineClassDayDetailQuery: 'BookSeatsApi/API_LineClassDayDetailQuery', //获取班次详情
    WX_TicketOrderQuery: 'BookSeatsApi/WX_TicketOrderQuery', //订单列表获取
    WX_TicketOrderDetailQuery: 'BookSeatsApi/WX_TicketOrderDetailQuery', //订单详情获取
    WX_WXUserContactQuery: 'BookSeatsApi/WX_WXUserContactQuery', //获取联系人列表
    WX_WXUserContactDel: 'BookSeatsApi/WX_WXUserContactDel', //删除联系人
    WX_WXUserContactSave: 'BookSeatsApi/WX_WXUserContactSave', //编辑联系人
    WX_LineClassDayTicketPriceQuery: 'BookSeatsApi/WX_LineClassDayTicketPriceQuery', //班次价格获取
    API_TicketOrderCreate: 'BookSeatsApi/API_TicketOrderCreate', //下单  计价校验
    API_TicketOrderCommit: 'BookSeatsApi/API_TicketOrderCommit', //订单提交
    API_PayDo: 'BookSeatsApi/API_PayDo', //支付
    WX_GetWXUserInfo: 'BookSeatsApi/WX_GetWXUserInfo', //获取微信用户个人信息
    WX_EditWXUserInfo: 'BookSeatsApi/WX_SaveWXUserInfo', //保存用户个人信息
    API_GetBackRate: 'BookSeatsApi/API_GetBackRate', //获取退票费率
    API_TicketBackCommit: 'BookSeatsApi/API_TicketBackCommit', //退票提交
    API_TicketOrderCancel: 'BookSeatsApi/API_TicketOrderCancel', //订单取消
    API_TicketInsuranceRefund: 'BookSeatsApi/API_TicketInsuranceRefund', //保险退废
    WX_TicketOrderDetailCheck: 'BookSeatsApi/API_TicketOrderCheck', //订单检票
    WX_GetQrCode: 'BookSeatsApi/GetQrCode', //获取二维码
    API_InsuranceQuery: 'BookSeatsApi/API_InsuranceQuery',//获取保险
    API_JsApiCfgQuery: 'Home/GetJsSdkConfig',//获取保险
}